import axios from "axios";
import { ApiEndpoints } from "../utils/enums/api_endpoint";

import store from "./index.js";

export default {
    namespaced: true,
    state: {
        isAuthenticated: false,
        user: null,
        token: null,
        role: null,
        isLoading: false,
        permissions: [] ,// Add permissions array
        //for 403 logic
        validPermission: true,
        errorCode: null,
        errorMessage: '',
    },
    getters: {
        userPermissions: state => state.permissions || [] // Getter to retrieve user permissions
    },
    mutations: {
        setAuthenticated(state, isAuthenticated) {
            state.isAuthenticated = isAuthenticated;
        },
        setUser(state, { user, token, permissions }) {
            state.user = user;
            state.token = token;
            state.permissions = permissions;
        },
        setRole(state, { role }) {
            state.role = role;
        },
        setLoading(state, value) {
            state.isLoading = value;
        },
        setPermissionError(state, { validPermission, errorCode, errorMessage }) {
            state.validPermission = validPermission;
            state.errorCode = errorCode;
            state.errorMessage = errorMessage;
        },
    },
    actions: {
        async login({ commit }, userData) {
            try {
                const response = await axios.post(ApiEndpoints.LOGIN, userData);
                const { user, token, permissions, role } = response.data.data;
                commit('setAuthenticated', true);
                commit('setUser', { user, token, permissions });
                commit('setRole', {role});
                return response.data;
            } catch (error) {
                throw error.response.data;
            }
        },
        async logout({ commit }) {
            try {
                let token = store.state.auth.token;
                const response = await axios.get(ApiEndpoints.LOGOUT, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const user = null;
                 token = null;
                 const role = null;
                const permissions = [];
                commit('setAuthenticated', false);
                commit('setUser', { user, token, permissions });
                commit('setRole', {role});
            } catch (error) {
                throw error; // Throw an error with response data
            }
        },
        async checkAuth({ commit }) {
            try {
                const token = this.state.auth.token;
                const response = await axios.get(ApiEndpoints.CHECK_SESSION, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                commit('setAuthenticated', response.data.authenticated);
                if (!response.data.authenticated) {
                    await this.logout({ commit });
                }
            } catch (error) {
                commit('setAuthenticated', false);
                commit('setUser', {user: null, token: null, permissions: null});
                throw error.response.data; // Throw an error with response data
            }
        },
        async refreshSession({ commit, getters }, token) {
            try {
                if (!token) {
                    throw new Error("Token is missing.");
                }
                const response = await axios.get(ApiEndpoints.REFRESH_SESSION, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data) {
                    const { user, token, permissions } = response.data;
                    commit('setAuthenticated', true);
                    commit('setUser', { user, token, permissions: getters.userPermissions }); // Set user, token, and permissions
                } else {
                    commit('setAuthenticated', false);
                    commit('setUser', { user: null, token: null, permissions: [] }); // Clear user, token, and permissions
                }

                return response.data; // Return the response data
            } catch (error) {
                commit('setAuthenticated', false);
                commit('setUser', null);
                throw error; // Throw an error with response data
            }
        },

        // Function to check if the user has permission to access a certain route
        hasPermission({ state, getters }, { url, action }) {
            // Retrieve user permissions from state
            const permissions = getters.userPermissions;

            // Check if the user has permission for the given routeName and action using a for loop
            let result = false;
            for (let i = 0; i < permissions.length; i++) {
                const permission = permissions[i];
                // Parse actions if it is a string representation of an array
                let actionsArray = permission.actions;
                if (typeof permission.actions === 'string') {
                    try {
                        actionsArray = JSON.parse(permission.actions);
                    } catch (e) {
                        console.error("Failed to parse actions:", permission.actions);
                    }
                }
                if (permission.url === url && actionsArray.includes(action)) {
                    result = true;
                    break;
                }
            }

            return true;
        }


    }
};
